module.exports = __webpack_public_path__ + "static/media/predictivu.d2290dcf.png";